import * as React from "react"
import { cn } from "../../lib/utils"

/**
 * ScrollableTableContainer - A container for tables that enables proper scrolling
 * with trackpad/mouse wheel within a fixed height area
 */
export const ScrollableTableContainer = React.forwardRef(({ 
  className, 
  children,
  maxHeight = "400px",
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "scrollbar-thin",
        className
      )}
      style={{
        maxHeight,
        overflowY: 'scroll',  // Force scrollbar to always show
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain'
      }}
      {...props}
    >
      {children}
    </div>
  )
})

ScrollableTableContainer.displayName = "ScrollableTableContainer"

export default ScrollableTableContainer
